import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32f83c1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overlay" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("u", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "/" }, "Skat32")
  ])
], -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Ich spiele!", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 2 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "Du bist dran!", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 3,
  class: "ind"
}
const _hoisted_12 = { key: 4 }
const _hoisted_13 = { key: 5 }

import { GameStage } from "@/GameEnums";
import { GameMode } from "@/GameEnums";



export default /*#__PURE__*/_defineComponent({
  __name: 'OverlayComponent',
  props: {
    stage: Number,
    gameId: String,
    playerToken: String,
    turn: Boolean,
    playing: Boolean,
    playersCount: Number,
    mode: String,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (__props.stage === _unref(GameStage).REIZEN && __props.playersCount === 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('doneReizen')))
          }, _hoisted_5)
        ]))
      : _createCommentVNode("", true),
    (__props.stage === _unref(GameStage).STOCK && __props.playing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(GameMode), (m) => {
            return (_openBlock(), _createElementBlock("button", {
              onClick: ($event: any) => (_ctx.$emit('doneStock', m)),
              key: m
            }, _toDisplayString(m), 9, _hoisted_7))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (__props.turn && __props.stage == _unref(GameStage).SPIEL)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
      : _createCommentVNode("", true),
    (__props.playing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, " EINZELN "))
      : _createCommentVNode("", true),
    (__props.stage === _unref(GameStage).SPIEL)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("b", null, "Es wird " + _toDisplayString(__props.mode) + " gespielt.", 1)
        ]))
      : _createCommentVNode("", true),
    (__props.stage == _unref(GameStage).SPIEL)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('reset')))
          }, "Neues Spiel.")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})